import React from 'react';
import PropTypes from 'prop-types';
import { ChipField as RAChipField } from 'react-admin';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles({
	small: {
		height: '20px',
	}
});

const ChipField = ({ record, source, ...props }) => {
	const classes = useStyles();

	return (
		record && (record[source] !== undefined && record[source] !== null) ? 
			<RAChipField className={props.size === 'small' ? classes.small : ''} {...{ record, source, ...props }} /> 
		: null
	);
};

ChipField.defaultProps = {
	color: "default",
	size: "medium"
};

ChipField.propTypes = {
	source: PropTypes.string.isRequired,
	size: PropTypes.oneOf(["small", "medium"]),
	color: PropTypes.string
};

export default ChipField;